<script>
import Carriers from '@/views/Application/Manage/Accounts/Account/Configuration/Carriers'
export default {
  extends: Carriers,
  data () {
    return {
      breadcrumb: {
        name: 'Carriers',
        route: { name: 'sales-accounts-account-carriers', params: { accountId: this.$route.params.accountId } }
      }
    }
  }
}
</script>
